import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader,
  AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export const btn = "inline-flex h-10 items-center justify-center gap-2 rounded-lg px-4 text-sm font-semibold transition-[opacity,background-color] disabled:opacity-50";
export const primary = `${btn} bg-foreground text-background hover:opacity-90`;
export const outline = `${btn} border bg-card text-foreground hover:bg-muted`;
export const danger = `${btn} bg-red-600 text-white hover:bg-red-700`;

export const ConfirmButton = ({ title, description, confirm, onConfirm, className, children, testId, disabled }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button type="button" className={className} disabled={disabled} data-testid={testId}>{children}</button>
    </AlertDialogTrigger>
    <AlertDialogContent data-testid={`${testId}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} data-testid={`${testId}-confirm`}>{confirm}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
